import { ModuleWithProviders, NgModule } from "@angular/core";

import { ScsAuthorizationTokenParser } from "./scs-authorizatio-token.parser";
import { UserCredentialsParser } from "./user-credentials.parser";
import { HealthParser } from "./health.parser";
import { UserCredentialsActivationParser } from "./user-credentials-activation.parser";
import { PowerBiReportParser } from "./powerbi-report-parser";
import { NewsParser } from "./news.parser";
import { ImportFileParser } from "./pbm/beneficiary/import-file.parser";
import { SearchCompanyParser } from "./pbm/company/search-company.parser";
import { CompanyParser } from "./pbm/company/company.parser";
import { AddCompanyParser } from "./pbm/company/add-company.parser";
import { ContactParser } from "./pbm/company/contact.parser";
import { AddContactParser } from "./pbm/company/add-contact.parser";
import { ProductTypeParser } from "./pbm/benefit/product-type.parser";
import { PaymentTypeParser } from "./pbm/benefit/payment-type.parser";
import { ProductSubtypeParser } from "./pbm/benefit/product-subtype.parser";
import { BenefitConfigurationParser } from "./pbm/benefit/benefit-configuration.parser";
import { ProductConfigurationParser } from "./pbm/benefit/product-configuration.parser";
import { NetworkProductConfigurationParser } from "./pbm/benefit/network-product-configuration.parser";
import { NetworkParser } from "./pbm/benefit/network.parser";
import { ProductCategoryParser } from "./pbm/benefit/product-category.parser";
import { TransactionConfigurationParser } from "./pbm/benefit/transaction-configuration.parser";
import { MedicalPrescriptionConfigurationParser } from "./pbm/benefit/medical-prescription-configuration.parser";
import { MedicalPrescriptionValidityParser } from "./pbm/benefit/medical-prescription.parser";
import { LifeCycleConfigurationParser } from "./pbm/benefit/life-cycle-configuration.parser";
import { SubsidyConfigurationParser } from "./pbm/benefit/subsidy-configuration.parser";
import { FindBeneficiaryByKeyParser } from "./pbm/beneficiary/find-beneficiary-by-key.parser";
import { SaveBenficiaryParser } from "./pbm/beneficiary/save-beneficiary.parser";
import { SearchCompanyFromMDMParser } from "./pbm/company/search-company-from-mdm.parser";
import { FindSalesHistoryParser } from "./pbm/sales-history/find-sales-history.parser";
import { FindSalesHistoryByFiscalNumberParser } from "./pbm/sales-history/find-sales-history-by-fiscal-number.parser";
import { SearchUserParser } from "./pbm/user/search-user.parser";
import { SearchUserByUserKeyParser } from "./pbm/user/search-user-by-user-key.parser";
import { RequestUserRolesParser } from "./pbm/user/request-user-roles.parser";
import { UserCredentialParser } from "./pbm/user/user-credential.parser";
import { SearchProductsByParser } from "./pbm/benefit/search-products-by.parser";
import { SearchTherapeuticClassesByParser } from "./pbm/benefit/search-therapeutic-classes-by.parser";
import { ResponseErrorParser } from "./pbm/response-error.parser";
import { FindBeneficiariesByFiscalNumberParser } from "./pbm/beneficiary/find-beneficiaries-by-fiscal-number.parser";
import { FindBeneficiaryHolderBySocialNumberParser } from "./pbm/beneficiary/find-beneficiary-by-holder-social-number.parser";
import { FindBeneficiaryBySocialNumberParser } from "./pbm/beneficiary/find-beneficiary-by-social-number.parser";
import { FindFinancialStatementParser } from "./pbm/financial-statement/find-financial-statement.parse";
import { FindFinancialBalanceBySocialNumberParser } from "./pbm/financial-statement/financial-balance.parser";
import { StateAcronymParser } from "./pbm/state/state-acronym.parser";
import { CityParser } from "./pbm/state/city.parser";
import { BeneficiaryConfigurationParser } from "./pbm/benefit/beneficiary-configuration.parser";
import { GetFileExportStatusParser } from "./get-file-export-status.parser";
import { ExportFileParser } from "./export-file.parser";
import { BlockReasonListParser } from "./pbm/beneficiary/block-reason-list.parser";
import { JobDescriptionParser } from "./pbm/job-description/job-description.parser";
import { OrderBeneficiaryCardParser } from "./pbm/beneficiary/order-beneficiary-card.parser";
import { IndicatorDataParser } from "./pbm/indicator/indicator-data.parser";
import { CompanyFinancialReportsParser } from "./pbm/company/company-financial-reports.parser";
import { SearchNetworkFinancialStatementsParse } from "./pbm/network/search-network-financial-statement.parse";
import { IndustryDiscountsPageableResultParser } from "./pbm/industry/industry-discounts-pageable-result.parser";
import { ImportIndustryProductDiscountParser } from "./pbm/industry/import-industry-product-discount.parser";
import { IndustryDiscountParser } from "./pbm/industry/industry-discount.parser";
import { SearchProductsParser } from "./pbm/product-management/search-products.parser";
import { ProductTypesParser } from "./pbm/product-management/product-types.parser";
import { ProductSubTypesParser } from "./pbm/product-management/product-sub-types.parser";
import { TherapeuticClassParser } from "./pbm/product-management/therapeutic-class.parser";
import { ProductUseValiditiesParser } from "./pbm/product-management/product-use-validities.parser";
import { ProductPricingsParser } from "./pbm/product-management/product-pricings.parser";
import { PriceRegimesParser } from "./pbm/product-management/price-regimes.parser";
import { UseTypesParser } from "./pbm/product-management/use-types.parser";
import { TributaryCreditConcessionsParser } from "./pbm/product-management/tributary-credit-concessions.parser";
import { ProductPrincingTemplateParser } from "./pbm/product-management/product-pricing-template.parser";
import { IndicatorsParser } from "./pbm/transaction-management/indicators.parser";
import { TransactionalManagementResultParser } from "./pbm/transaction-management/transaction-management-result.parser";
import { ExportFileAsXLSXParser } from "./export-file-as-xlsx.parser";
import { SearchPractitionersParser } from "./pbm/practitioner-management/search-practitioners.parser";
import { PractitionerSpecialtiesParser } from "./pbm/practitioner-management/practitioner-specialties.parser";
import { SearchPractitionerByKeyParser } from "./pbm/practitioner-management/search-practitioner-by-key.parser";
import { PractitionerStatusParser } from "./pbm/practitioner-management/practitioner-status.parser";
import { NetworkExternalConfigurationParse } from "./pbm/network/network-external-configuration.parser";
import { ClustersPageableResultParser } from "./pbm/clusters/clusters-pageable-result.parser";
import { AddNewClusterParser } from "./pbm/clusters/add-new-cluster.parser";
import { ClusterProductsPageableResultParser } from "./pbm/clusters/clusters-products-pageable-result.parser";
import { ImportFileClusterParser } from "./pbm/clusters/import-cluster-file.parser";
import { ClusterParser } from "./pbm/clusters/cluster.parser";
import { CompanyConfigurationParser } from "./pbm/company/company-configuration.parser";
import { ZipCodeIntegrationParser } from "./pbm/beneficiary/zip-code-integration.parser";

@NgModule({})
export class ParserModule {
  static forRoot(): ModuleWithProviders<ParserModule> {
    return {
      ngModule: ParserModule,
      providers: [
        ScsAuthorizationTokenParser,
        UserCredentialsParser,
        HealthParser,
        UserCredentialsActivationParser,
        PowerBiReportParser,
        NewsParser,
        ImportFileParser,
        SaveBenficiaryParser,
        SearchCompanyParser,
        CompanyParser,
        AddCompanyParser,
        ContactParser,
        AddContactParser,
        SearchCompanyFromMDMParser,
        BenefitConfigurationParser,
        ProductConfigurationParser,
        ProductTypeParser,
        PaymentTypeParser,
        ProductSubtypeParser,
        SearchProductsByParser,
        SearchTherapeuticClassesByParser,
        NetworkProductConfigurationParser,
        NetworkParser,
        ProductCategoryParser,
        ZipCodeIntegrationParser,
        MedicalPrescriptionValidityParser,
        TransactionConfigurationParser,
        MedicalPrescriptionConfigurationParser,
        SubsidyConfigurationParser,
        BeneficiaryConfigurationParser,
        LifeCycleConfigurationParser,
        FindSalesHistoryParser,
        FindSalesHistoryByFiscalNumberParser,
        SearchUserParser,
        SearchUserByUserKeyParser,
        RequestUserRolesParser,
        UserCredentialParser,
        ResponseErrorParser,
        FindBeneficiaryByKeyParser,
        FindBeneficiariesByFiscalNumberParser,
        FindBeneficiaryHolderBySocialNumberParser,
        FindBeneficiaryBySocialNumberParser,
        FindFinancialStatementParser,
        FindFinancialBalanceBySocialNumberParser,
        StateAcronymParser,
        CityParser,
        GetFileExportStatusParser,
        ExportFileParser,
        ExportFileAsXLSXParser,
        BlockReasonListParser,
        JobDescriptionParser,
        OrderBeneficiaryCardParser,
        IndicatorDataParser,
        CompanyFinancialReportsParser,
        SearchNetworkFinancialStatementsParse,
        IndustryDiscountsPageableResultParser,
        IndustryDiscountParser,
        ImportIndustryProductDiscountParser,
        SearchProductsParser,
        ProductTypesParser,
        ProductSubTypesParser,
        TherapeuticClassParser,
        ProductUseValiditiesParser,
        ProductPricingsParser,
        PriceRegimesParser,
        UseTypesParser,
        TributaryCreditConcessionsParser,
        ProductPrincingTemplateParser,
        IndicatorsParser,
        TransactionalManagementResultParser,
        SearchPractitionersParser,
        PractitionerSpecialtiesParser,
        SearchPractitionerByKeyParser,
        PractitionerStatusParser,
        NetworkExternalConfigurationParse,
        ClusterParser,
        ClustersPageableResultParser,
        ClusterProductsPageableResultParser,
        ImportFileClusterParser,
        AddNewClusterParser,
        CompanyConfigurationParser,
      ],
    };
  }
}
